import { get, post, put, deleted } from '../utils/http';

export function getWarrantyForm(param, code) {
    return post(`${code}warranty/getform`, param);
};

export function sendWarrantyForm(param, code) {
    return post(`${code}warranty/submitform`, param);
};

export function checkWarrantyPeriod(param, code) {
    return post(`${code}warranty/queryform`, param);
};

export function sendSystemMessage(param, code) {
    return post(`${code}warranty/sendsysmessage`, param);
}

export function verifyOtp(param, code) {
    return post(`${code}warranty/verifyotp`, param);
}